import type { FC, ReactElement } from "react";

import { StyledChipsOperator, StyledOperatorsChipItemText } from "./styles";

interface IFiltersOperatorsChipProps {
    operator?: string;
    itemTitle: string;
}

export const FiltersChipOperatorItem: FC<IFiltersOperatorsChipProps> = ({ operator, itemTitle }): ReactElement => {
    return (
        <>
            {operator ? <StyledChipsOperator>{operator}</StyledChipsOperator> : null}
            <StyledOperatorsChipItemText>{itemTitle}</StyledOperatorsChipItemText>
        </>
    );
};
